import { Component } from '@angular/core';
import { BaseFormDirective } from 'src/app/directives/base-form.directive';

@Component({
  selector: 'app-wall-form',
  templateUrl: './wall-form.component.html',
  styleUrls: ['./wall-form.component.sass']
})
export class WallFormComponent extends BaseFormDirective {
  override title = 'MENU.CITIES'
  override form = {
    name_: null,
    description_: null
  }
  path = 'city'
  states = []




  override getItemEdit() {
    this.editService = this.data.core.wallUnique(this.editId)
    super.getItemEdit()
  }

  override setSubmitMethods(): void {
    this.postService = this.data.core.wallCreate(this.formSanitized)
    this.putService = this.data.core.wallUpdate(this.editId, this.formSanitized)
  }
}

